import { toIso } from '../format'
import { useGetAdvancedUncancelledInProgramCallsQuery } from './advancedUncancelledInProgramCalls.generated'

export type InProgramCall = { id: string; startTime: string; noteLinked: boolean }

export const useUncancelledInProgramCalls = (uid: string): { loading: boolean; calls: InProgramCall[] } => {
  const { data, loading } = useGetAdvancedUncancelledInProgramCallsQuery({ variables: { uid } })
  const calls = data?.patient?.inProgramVideoCallBookingInformation?.uncancelledCalls ?? []

  return {
    loading,
    calls: calls.map((call) => ({
      id: call.id,
      startTime: toIso(call.startTime) ?? '',
      noteLinked: Boolean(call.checkInCallPatientHistoryEntryID),
    })),
  }
}
